// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const FlatList = createStyle({});
